export default "__VITE_ASSET__470431d1__"